<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <a-form :form="form" @submit="handleSubmit">
      <a-row class="items">
        <a-col :span="10">
          <a-form-item label="姓名" :label-col="{ span: 8}" :wrapper-col="{ span:12 }">
            <a-input
              placeholder="请输入真实姓名"
              v-decorator="[
          'fullName',
          {rules: [{ required: true, message: '请输入真实姓名!' }],initialValue:info.fullName}
        ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="单位名称" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-input
              placeholder="请输入单位名称"
              v-decorator="[
          'company',
          {rules: [{ required: true, message: '请输入单位名称!' }],initialValue:info.company}
        ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="性别" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-radio-group
              @change="onChange"
              v-decorator="[
                'sex',
                {rules: [{ required: true, message: '请选择性别!' }],initialValue:info.sex}
              ]"
            >
              <a-radio value="男">男</a-radio>
              <a-radio value="女">女</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="主管部门" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-select
              placeholder="请选择主管部门"
              v-decorator="[
          'administration',
          {rules: [{ required: true, message: '请选择主管部门!' }],initialValue:info.administration}
        ]"
            >
              <a-select-option
                :value="info.itemName"
                v-for="(info, index) in administrationList"
                :key="index"
              >{{info.itemName}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="民族" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-select
              placeholder="请选择民族"
              v-decorator="[
          'nation',
          {rules: [{ required: false, message: '请选择民族!' }],initialValue:extensions.nation}
        ]"
            >
              <a-select-option value>请选择民族</a-select-option>
              <a-select-option value="汉族">汉族</a-select-option>
              <a-select-option value="蒙古族">蒙古族</a-select-option>
              <a-select-option value="回族">回族</a-select-option>
              <a-select-option value="藏族">藏族</a-select-option>
              <a-select-option value="维吾尔族">维吾尔族</a-select-option>
              <a-select-option value="苗族">苗族</a-select-option>
              <a-select-option value="彝族">彝族</a-select-option>
              <a-select-option value="壮族">壮族</a-select-option>
              <a-select-option value="布依族">布依族</a-select-option>
              <a-select-option value="朝鲜族">朝鲜族</a-select-option>
              <a-select-option value="满族">满族</a-select-option>
              <a-select-option value="侗族">侗族</a-select-option>
              <a-select-option value="瑶族">瑶族</a-select-option>
              <a-select-option value="白族">白族</a-select-option>
              <a-select-option value="土家族">土家族</a-select-option>
              <a-select-option value="哈尼族">哈尼族</a-select-option>
              <a-select-option value="哈萨克族">哈萨克族</a-select-option>
              <a-select-option value="傣族">傣族</a-select-option>
              <a-select-option value="黎族">黎族</a-select-option>
              <a-select-option value="傈僳族">傈僳族</a-select-option>
              <a-select-option value="佤族">佤族</a-select-option>
              <a-select-option value="畲族">畲族</a-select-option>
              <a-select-option value="高山族">高山族</a-select-option>
              <a-select-option value="拉祜族">拉祜族</a-select-option>
              <a-select-option value="水族">水族</a-select-option>
              <a-select-option value="东乡族">东乡族</a-select-option>
              <a-select-option value="纳西族">纳西族</a-select-option>
              <a-select-option value="景颇族">景颇族</a-select-option>
              <a-select-option value="柯尔克孜族">柯尔克孜族</a-select-option>
              <a-select-option value="土族">土族</a-select-option>
              <a-select-option value="达斡尔族">达斡尔族</a-select-option>
              <a-select-option value="仫佬族">仫佬族</a-select-option>
              <a-select-option value="羌族">羌族</a-select-option>
              <a-select-option value="布朗族">布朗族</a-select-option>
              <a-select-option value="撒拉族">撒拉族</a-select-option>
              <a-select-option value="毛南族">毛南族</a-select-option>
              <a-select-option value="仡佬族">仡佬族</a-select-option>
              <a-select-option value="锡伯族">锡伯族</a-select-option>
              <a-select-option value="阿昌族">阿昌族</a-select-option>
              <a-select-option value="普米族">普米族</a-select-option>
              <a-select-option value="塔吉克族">塔吉克族</a-select-option>
              <a-select-option value="怒族">怒族</a-select-option>
              <a-select-option value="乌孜别克族">乌孜别克族</a-select-option>
              <a-select-option value="俄罗斯族">俄罗斯族</a-select-option>
              <a-select-option value="鄂温克族">鄂温克族</a-select-option>
              <a-select-option value="德昂族">德昂族</a-select-option>
              <a-select-option value="保安族">保安族</a-select-option>
              <a-select-option value="裕固族">裕固族</a-select-option>
              <a-select-option value="京族">京族</a-select-option>
              <a-select-option value="塔塔尔族">塔塔尔族</a-select-option>
              <a-select-option value="独龙族">独龙族</a-select-option>
              <a-select-option value="鄂伦春族">鄂伦春族</a-select-option>
              <a-select-option value="赫哲族">赫哲族</a-select-option>
              <a-select-option value="门巴族">门巴族</a-select-option>
              <a-select-option value="珞巴族">珞巴族</a-select-option>
              <a-select-option value="基诺族">基诺族</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="行政职务" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-input
              placeholder="请输入行政职务"
              v-decorator="[
          'post',
          {rules: [{ required: false, message: '请输入行政职务!' }],initialValue:info.post}
        ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="政治面貌" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-select
              placeholder="请选择政治面貌"
              v-decorator="[
          'politic',
          {rules: [{ required: false, message: '请选择政治面貌!' }],initialValue:extensions.politic}
        ]"
            >
              <a-select-option value>请选择政治面貌</a-select-option>
              <a-select-option value="中共党员">中共党员</a-select-option>
              <a-select-option value="中共预备党员">中共预备党员</a-select-option>
              <a-select-option value="共青团员">共青团员</a-select-option>
              <a-select-option value="群众">群众</a-select-option>
              <a-select-option value="民革党员">民革党员</a-select-option>
              <a-select-option value="民盟党员">民盟党员</a-select-option>
              <a-select-option value="民建会员">民建会员</a-select-option>
              <a-select-option value="民进会员">民进会员</a-select-option>
              <a-select-option value="农民党党员">农民党党员</a-select-option>
              <a-select-option value="致公党党员">致公党党员</a-select-option>
              <a-select-option value="九三学社社员">九三学社社员</a-select-option>
              <a-select-option value="台盟盟员">台盟盟员</a-select-option>
              <a-select-option value="无党派人士">无党派人士</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="职称系列" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-select
              placeholder="请选择职称系列"
              v-decorator="[
          'titleSet',
          {rules: [{ required: false, message: '请选择职称系列!' }],initialValue:extensions.titleSet}
        ]"
            >
              <a-select-option
                :value="info.itemName"
                v-for="(info, index) in jobSetList"
                :key="index"
              >{{info.itemName}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="证件号" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-input
              placeholder="请输入证件号"
              v-decorator="[
          'idCard',
          {rules: [{ required: true,validator:  (rule, val, callback) => {
                  if (!/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(val)){
                  callback('请输入正确的证件号');
                  }else {
                  callback();
                  }
                  callback();
                  },
                  }],initialValue:info.idCard}

        ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="职称" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-select
              placeholder="请选择职称"
              v-decorator="[
          'title',
          {rules: [{ required: false, message: '请选择职称!' }],initialValue:info.title}
        ]"
            >
              <a-select-option
                :value="info.itemName"
                v-for="(info, index) in titleList"
                :key="index"
              >{{info.itemName}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="手机号" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-input
              placeholder="请输入手机号"
              v-decorator="[
          'telephone',
          {rules: [{required: true, validator:  (rule, val, callback) => {
                  if (!/^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/.test(val)){
                  callback('请输入正确的手机号');
                  }else {
                  callback();
                  }
                  callback();
                  },
                  }],initialValue:info.telephone}
        ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="职称证书获取时间" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-date-picker
              :size="size"
              format="YYYY-MM-DD"
              @change="gainCreTimeChange"
              v-if="extensions.gainCreTime"
              :value="this.$moment(extensions.gainCreTime, 'YYYY-MM-DD')"
            ></a-date-picker>
            <a-date-picker
              :size="size"
              format="YYYY-MM-DD"
              placeholder="职称证书获取时间"
              @change="gainCreTimeChange"
              v-else
              v-decorator="[
          'gainCreTime',
          {rules: [{ required: false, message: '请选择职称证书获取时间!' }],initialValue:info.gainCreTime}
        ]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="邮箱" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-input
              placeholder="请输入邮箱"
              v-decorator="[
          'email',
          {rules: [{ required: false, message: '请输入邮箱!' }],initialValue:info.email}
        ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="聘任时间" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-date-picker
              :size="size"
              format="YYYY-MM-DD"
              @change="appointmentTimeChange"
              v-if="extensions.appointmentTime"
              :value="this.$moment(extensions.appointmentTime, 'YYYY-MM-DD')"
            ></a-date-picker>
            <a-date-picker
              :size="size"
              format="YYYY-MM-DD"
              placeholder="聘任时间"
              @change="appointmentTimeChange"
              v-else
              v-decorator="[
          'appointmentTime',
          {rules: [{ required: false, message: '请选择聘任时间!' }],initialValue:info.appointmentTime}
        ]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="所在地区" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-cascader
              :options="areas"
              placeholder="请选择所在地区"
              @change="areaChange"
              :default-value="areaList"
              :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item label="在岗状态" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-select
              placeholder="请选择在岗状态"
              v-decorator="[
          'state',
          {rules: [{ required: false, message: '请选择在岗状态!' }],initialValue:extensions.state}
        ]"
            >
              <a-select-option value="0">在岗</a-select-option>
              <a-select-option value="1">不在岗</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item :wrapper-col="{ span: 24, offset: 10 }" style="margin-top:20px;">
        <pxkeji-btn name="保存" type="primary" htmlType="submit" />
        <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
        <!--            <pxkeji-btn name="保存" type="primary" htmlType="submit" @click="handleSubmit" />-->
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    infos: {
      type: Object,
      default: () => {},
    },
    id: 0,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {},
      extensions: {
        nation: "",
      },
      jobSetList: [],
      titleList: [],
      administrationList: [],
      servicelists: [],
      serviceNames: [],
      serviceIds: [],
      goodlists: [],
      goodNames: [],
      goodIds: [],
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      previewVisible: false,
      areas: [],
      areaList: [],
      size: "large",
      service: {
        //服务项目
        visible: false,
      },
      good: {
        //擅长项目
        visible: false,
      },
      schedule: {
        //排班
        visible: false,
        list: "",
      },
    };
  },
  components: {},
  mounted() {
    this.$nextTick(function () {

      that = this;
      if (this.id) {
        //编辑
        this.getInfo();
      }
      if (!this.type) {
        this.dis = true;
      }
      this.getArea();
      this.getDictionaryItem();
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    //获取数据字典
    getDictionaryItem() {
      this.$api.dictionaryItem.tree(23).then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.administrationList = res.data;
        } else {
          this.error(res.errorMsg);
        }
      });
      this.$api.dictionaryItem.tree(24).then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.jobSetList = res.data;
        } else {
          this.error(res.errorMsg);
        }
      });
      this.$api.dictionaryItem.tree(25).then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.titleList = res.data;
        } else {
          this.error(res.errorMsg);
        }
      });
    },
    getArea() {
      this.areas = this.$api.city.city;
    },
    areaChange(value) {
      this.info.province = value[0];
      this.info.city = value[1];
      this.info.area = value[2];
    },
    /**数据回显 */
    getInfo() {
      this.isloading = true;
      this.$api.student
        .getById(this.id)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            this.areaList.push(this.info.province);
            this.areaList.push(this.info.city);
            this.areaList.push(this.info.area);
            if (res.data.extensions != null) {
              this.extensions = JSON.parse(res.data.extensions);
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    //性别选择
    onChange(e) {
      this.info.sex = e.target.value;
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.extensions.nation = values.nation;
          this.extensions.politic = values.politic;
          this.extensions.state = values.state;
          this.extensions.gainCreTime = this.extensions.gainCreTime;
          this.extensions.appointmentTime = this.extensions.appointmentTime;
          this.extensions.titleSet = values.titleSet;
          var data = {
            id: that.id,
            sex: this.info.sex,
            fullName: values.fullName,
            idCard: values.idCard,
            email: values.email,
            telephone: values.telephone,
            province: this.info.province,
            city: this.info.city,
            area: this.info.area,
            company: values.company,
            administration: values.administration,
            post: values.post,
            title: values.title,
            extensions: JSON.stringify(this.extensions),
          };
          if (this.id) {
            //修改
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.student
              .updateById(data)
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //新增
            console.log("data", data);
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.student
              .save(data)
              .then((res) => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                  //this.form.resetFields();
                } else {
                  this.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },

    appointmentTimeChange(value, dateString) {
      this.extensions.appointmentTime = dateString;
    },
    gainCreTimeChange(value, dateString) {
      this.extensions.gainCreTime = dateString;
      console.log("gainCreTime", this.extensions.gainCreTime);
    },
    onCheckboxChange(e) {
      this.info.checked = e.target.checked;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      if (info.file.status) {
        this.fileList = info.fileList;
      }
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        },
      });
    },
  },
};
</script>
<style>
.scheduleBtn {
  color: #1890ff;
  cursor: pointer;
}

.signup_items {
  border: 1px #ddd solid;
}
.signup_basicinfo {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.signup_hpic {
  width: 140px;
  height: 160px;
  text-align: center;
  line-height: 150px;
  border-left: 1px #ddd solid;
  border-bottom: 1px #ddd solid;
}
.signup_hpic img {
  width: 100%;
  height: 100%;
}
.signup_bsleft {
  flex: 1;
}
.signup_bscol {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 40px;
  border-bottom: 1px #ccc solid;
}
.signup_bscol > div {
  height: 100%;
  border-right: 1px #ccc solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 130px;
  padding: 0 15px;
  box-sizing: border-box;
}
.signup_bscol > div:last-child {
  border: none;
}
.signup_tit {
  text-align: center;
  border-right: 1px #ccc solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 130px;
  padding: 0 15px;
  box-sizing: border-box;
}
.signup_bscol > div select,
.signup_bscol > div input {
  height: 30px;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding-left: 10px;
  width: 115px;
}
.extra_info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
}
.extra_info_fl {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-right: 1px #ccc solid;
  width: 50%;
  border-bottom: 1px #ccc solid;
  height: 40px;
}
.half_in {
  flex: 1;
  padding: 0 15px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: normal;
  word-break: keep-all;
}
.rejecttags {
  display: block;
}
.half_in input,
.half_in select {
  flex: 1;
  height: 30px;
  border: 1px #ddd solid;
  border-radius: 5px;
  padding-left: 10px;
}
.extra_info_fr {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  border-bottom: 1px #ddd solid;
}
.extra_info_fr .signup_tit {
  height: 100%;
}
.signup_tra {
  flex: 1;
  border: 1px #ddd solid;
  border-radius: 5px;
}
.extra_info2 {
  height: auto;
}
.extra_info2 > div {
  height: 100%;
}
.con_rt {
  border-left: 1px #ccc solid;
  padding: 10px;
}
.fmbox {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
}
.family_members {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px #ccc solid;
}
.family_members:last-child {
  border-bottom: none;
}
.family_members div {
  width: 25%;
  text-align: center;
  border-right: 1px #ccc solid;
}
.family_members div:last-child {
  border: none;
}
.family_members div input {
  width: 100%;
  text-align: center;
  border: none;
  box-shadow: none;
}
.signup_tit2 {
  border: none;
}
.checkTop {
  border-bottom: 1px #ccc solid;
}
.checkTop .half_in {
  padding: 5px 15px !important;
}
.fixInfo2 {
  border-bottom: 1px #ccc solid;
}
.fixInfo2 .extra_info_fl {
  border-right: 1px #ccc solid;
  border-bottom: none;
}
</style>